
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Pridajte ju na domovskú obrazovku pre rozšírené využitie a jednoduchý prístup.`,
's224cbcec014ef6b5': `Stlačte Zdieľať na navigačnom paneli`,
's37a9e8aec5713460': `Viac`,
's386eca8362ff6155': `Stlačte Viac, ak nevidíte ikonu Zdieľať`,
's4e1e10a6ca408245': `Klepnite na "Pridať na domovskú obrazovku"`,
's6196153c4b0c1ea0': `Inštalovať`,
's633502f7cff4f847': `Otvorte ponuku prehliadača`,
's681e399d63311fba': `Zobraziť galériu`,
's7f0591f08e318eda': `Stlačte Viac v menu Zdieľať`,
's8114bd55cae5a22b': `Stlačte Pridať do Docku`,
's922329d6f6213590': `Pridať do Docku`,
's9af56bf005b49c74': `Prejdite nadol k "Pridať na domovskú obrazovku"`,
'sa5ef80b4bb9b39f8': `Menej`,
'sba52286c21552a4e': `Nainštalujte si ju na svoje zariadenie pre rozšírené využitie a jednoduchý prístup.`,
'sc16e00a7a8b2fde2': `Späť`,
'scdaf4bbff76674c8': `Pridať na domovskú obrazovku`,
'se0e473adfda8066c': `Otvorte v hlavnom prehliadači`,
'se740f75b95a51807': `Pridajte ju do Docku pre rozšírené využitie a jednoduchý prístup.`,
'sfea652f6580ff086': `Táto stránka má funkcie aplikácie.`,
    };
  